import check from "../../../assets/selectAccount.png";
import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";

function Withdraw() {
  const { t } = useTranslation();

  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How to make a withdraw request in a group?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.Ikimina.withdraw.step1")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.Ikimina.withdraw.step2")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.Ikimina.withdraw.step3.part1")} <br />
          <ul className="list-disc pl-8">
            <li>
              <span className="font-semibold">
                {t("helpCenter.Ikimina.withdraw.step3.part2")}
              </span>
              {t("helpCenter.Ikimina.withdraw.step3.part3")}
            </li>
            <li>
              <span className="font-semibold">
                {t("helpCenter.Ikimina.withdraw.step3.part4")}
              </span>
              {t("helpCenter.Ikimina.withdraw.step3.part5")}
            </li>
          </ul>
          {t("helpCenter.Ikimina.withdraw.step3.part6")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.Ikimina.withdraw.step4")}
        </p>
        <p>
          <span className="font-semibold">Step 5: </span>
          {t("helpCenter.Ikimina.withdraw.step5")}
          <br /> <span className="font-semibold">Note: </span>
          {t("helpCenter.Ikimina.withdraw.note.part1")}
          <img src={check} alt="icon" className="inline-flex w-[160px]" />
          {t("helpCenter.Ikimina.withdraw.note.part2")}
        </p>
        <p>
          <span className="font-semibold">Step 6: </span>
          {t("helpCenter.Ikimina.withdraw.step6")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default Withdraw;
